<template>
  <v-flex xs12>
    <v-card>
      <v-card-title>
        <v-flex xs12 class="mb-5">
          <h4>{{ pageTitle }}</h4>
        </v-flex>
        <v-flex xs12>
          <v-form ref="form" lazy-validation @submit.prevent="submit">
            <v-container grid-list-xl>
              <v-layout wrap>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="title"
                    name="title"
                    label="Title"
                    :counter="100"
                    v-validate="'required|max:100'"
                    data-vv-as="Title"
                    :error-messages="errors.collect('title')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="url"
                    name="url"
                    label="Url"
                    :counter="100"
                    readonly="readonly"
                    v-validate="'required|max:100'"
                    data-vv-as="Url"
                    :error-messages="errors.collect('url')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="keywords"
                    name="keywords"
                    label="Keywords"
                    :counter="300"
                    v-validate="'required|max:300'"
                    data-vv-as="Keywords"
                    :error-messages="errors.collect('keywords')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="description"
                    name="description"
                    label="Description"
                    :counter="300"
                    v-validate="'required|max:300'"
                    data-vv-as="Description"
                    :error-messages="errors.collect('description')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="writer"
                    name="writer"
                    label="Writer"
                    :counter="50"
                    v-validate="'required|max:50'"
                    data-vv-as="Writer"
                    :error-messages="errors.collect('writer')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-menu
                    v-model="menu.publishDate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="publishDate"
                        label="Publish Date"
                        name="publishDate"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                        data-vv-as="Publish Date"
                        v-validate="'required'"
                        :error-messages="errors.collect('publishDate')"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="publishDate" @input="menu.publishDate = false"></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 md12>
                  <div class="v-list-item__subtitle">Content</div>
                  <quill-editor
                    v-model="content"
                    name="content"
                    ref="myQuillEditor"
                    v-validate="'required'"
                    :options="editorOption"
                    data-vv-as="Content"
                    :error-messages="errors.collect('content')"
                  ></quill-editor>
                  <div class="v-text-field__details" v-show="errors.has('content')">
                    <div class="v-messages theme--light error--text">
                      <div class="v-messages__wrapper">
                        <div class="v-messages__message">{{ errors.first("content") }}</div>
                      </div>
                    </div>
                  </div>
                </v-flex>
                <v-flex xs12 md12>
                  <v-combobox
                    v-model="tag"
                    :items="tagList"
                    chips
                    clearable
                    label="Enter Tags"
                    name="tag"
                    multiple
                    prepend-icon="filter_list"
                    data-vv-as="Tags"
                    v-validate="'required'"
                    :error-messages="errors.collect('tag')"
                  >
                    <template v-slot:selection="{ attrs, item, select, selected }">
                      <v-chip
                        v-bind="attrs"
                        :input-value="selected"
                        close
                        @click="select"
                        @click:close="remove(item)"
                      >
                        <strong>{{ item }}</strong>
                      </v-chip>
                    </template>
                  </v-combobox>
                </v-flex>
                <v-flex xs12 md1>
                  <v-btn color="info" type="button" @click="imagePicked">
                    <v-icon>cloud_upload</v-icon>Image
                  </v-btn>
                  <input
                    type="file"
                    style="display: none"
                    ref="ImageUploader"
                    accept="image/*"
                    @change="onImagePicked"
                  />
                </v-flex>
                <v-flex xs12 md4>
                  <vue-cropper
                    ref="cropper"
                    :aspect-ratio="ratio"
                    :src="mainImage"
                    :imageSmoothingEnabled="false"
                    alt="Upload Image"
                  ></vue-cropper>
                  <!-- <img :src="image" style="width:100%" v-if="image" /> -->
                  <br />
                  <v-btn color="info" type="button" @click="crop" v-if="showCrop">
                    <v-icon>crop</v-icon>Crop
                  </v-btn>
                </v-flex>
                <v-flex xs12 md4>
                  <img v-if="image" :src="image" alt="Cropped Image" style="width:100%" />
                </v-flex>
              </v-layout>
            </v-container>
            <v-divider class="mt-5"></v-divider>
            <v-card-actions>
              <v-btn color="success" type="submit">
                <v-icon>save</v-icon>Save
              </v-btn>
              <v-btn color="error" @click="reset">Reset</v-btn>
            </v-card-actions>
          </v-form>
        </v-flex>
      </v-card-title>
    </v-card>
  </v-flex>
</template>

<script>
import store from "../../store";
import commonservice from "../../shared/common.service";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
export default {
  components: { VueCropper },
  computed: {
    title: {
      get() {
        return this.$store.state.blog.entity.title;
      },
      set(val) {
        this.$store.commit("blog/SET_BLOG_DATA", {
          key: "title",
          value: val
        });
        val = val.toLowerCase();
        this.$store.commit("blog/SET_BLOG_DATA", {
          key: "url",
          value: val.replace(/\s+/g, "-")
        });
      }
    },
    url: {
      get() {
        return this.$store.state.blog.entity.url;
      }
    },
    writer: {
      get() {
        return this.$store.state.blog.entity.writer;
      },
      set(val) {
        this.$store.commit("blog/SET_BLOG_DATA", {
          key: "writer",
          value: val
        });
      }
    },
    content: {
      get() {
        return this.$store.state.blog.entity.content;
      },
      set(val) {
        this.$store.commit("blog/SET_BLOG_DATA", {
          key: "content",
          value: val
        });
      }
    },
    publishDate: {
      get() {
        return this.$store.state.blog.entity.publishDate;
      },
      set(val) {
        this.$store.commit("blog/SET_BLOG_DATA", {
          key: "publishDate",
          value: val
        });
      }
    },
    tag: {
      get() {
        return this.$store.state.blog.entity.tag;
      },
      set(val) {
        this.$store.commit("blog/SET_BLOG_DATA", {
          key: "tag",
          value: val
        });
      }
    },
    keywords: {
      get() {
        return this.$store.state.blog.entity.keywords;
      },
      set(val) {
        this.$store.commit("blog/SET_BLOG_DATA", {
          key: "keywords",
          value: val
        });
      }
    },
    description: {
      get() {
        return this.$store.state.blog.entity.description;
      },
      set(val) {
        this.$store.commit("blog/SET_BLOG_DATA", {
          key: "description",
          value: val
        });
      }
    },
    tagList: {
      get() {
        return this.$store.state.blog.tagList;
      }
    },
    image: {
      get() {
        return this.$store.state.blog.entity.image;
      },
      set(val) {
        this.$store.commit("blog/SET_BLOG_DATA", {
          key: "image",
          value: val
        });
      }
    },
    mainImage: {
      get() {
        return this.$store.state.blog.mainImage;
      },
      set(val) {
        this.$store.commit("blog/SET_BLOG_DATA", val);
      }
    }
  },
  data() {
    return {
      pageTitle: "Add Blog",
      loading: false,
      menu: {
        publishDate: false
      },
      menu1: false,
      ratio: 1.29,
      showCrop: false,
      editorOption: {
        // some quill options
      }
    };
  },
  beforeRouteEnter(to, from, next) {
    if (to.params.id) {
      store.dispatch("blog/setBlog", { id: to.params.id }).then(() => {
        next(p => {
          p.pageTitle = "Edit Blog";
        });
      });
    } else {
      next(p => {
        p.reset();
      });
    }
  },
  methods: {
    submit() {
      if (this.loading) return;
      if (this.image == null) {
        commonservice.showErrorMessage("Please upload image");
        return;
      }
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;
          this.$store
            .dispatch("blog/saveBlog")
            .then(
              () => {
                commonservice.showSuccessMessage("Blog saved successfully");
                this.$router.push("/blog");
                this.loading = false;
              },
              () => {
                this.loading = false;
              }
            )
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
    reset() {
      this.$store.commit("blog/RESET");
      setTimeout(() => {
        this.errors.clear();
      }, 10);
    },
    remove(item) {
      console.log(item);
      // this.chips.splice(this.chips.indexOf(item), 1);
      // this.chips = [...this.chips];
    },
    imagePicked() {
      this.$refs.ImageUploader.click();
    },
    crop() {
      var self = this;
      // get image data for post processing, e.g. upload or setting image src
      var cropIm = self.$refs.cropper
        .getCroppedCanvas({ imageSmoothingEnabled: false })
        .toDataURL("image/jpeg", 0.7);
      self.$store.commit("blog/SET_BLOG_DATA", {
        key: "image",
        value: cropIm
      });
    },
    onImagePicked(event) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      var self = this;
      reader.onload = function() {
        self.$store.commit("blog/SET_MAIN_IMAGE", reader.result);
        self.$refs.cropper.replace(reader.result);
        self.showCrop = true;
      };
    }
  }
};
</script>
